import dayjs from 'dayjs/esm';
import Cookies from 'js-cookie';
import './dist/message';

window.Cookies = Cookies;
window.dayjs = dayjs;
